import React from 'react'
import "./AboutTabContent.css"

const AboutTabmission = () => {
    return (
        <div className="about-tab-contents">
            <h2 className="about-tab-contents-h2">
                Our mission
            </h2>
            <p className="about-tab-contents-p">
                940 Air Cargo provides logistical solutions to local exporters, importers, and international organizations within Africa and globally. We strive to be the bridge that connects African businesses to the world.
            </p>
            <ul>
                <li>To provide seamless logistical support.</li>
                <li>To ensure timely and safe delivery of cargo.</li>
                <li>To build long-term relationships with our partners.</li>
                <li>To be the leading logistics provider in the region.</li>
            </ul>
        </div>
    )
}

export default AboutTabmission
